import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IntroSplash } from "@/components/IntroSplash";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ScienceHub from "@/pages/ScienceHub";
import ConditionPage from "@/pages/ConditionPage";
import Recipes from "@/pages/Recipes";
import ComingSoon from "@/pages/ComingSoon";
import Community from "@/pages/Community";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PressKit from "@/pages/PressKit";
import Go from "@/pages/Go";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  const [splashDone, setSplashDone] = useState(() => sessionStorage.getItem("pk_intro") === "1");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-paper">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <AnimatePresence>
          {!splashDone && <IntroSplash onDone={() => setSplashDone(true)} />}
        </AnimatePresence>
        <Navbar />
        {splashDone && (
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/science" element={<ScienceHub />} />
              <Route path="/science/:slug" element={<ConditionPage />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/coming-soon" element={<ComingSoon />} />
              <Route path="/community" element={<Community />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/press-kit" element={<PressKit />} />
              <Route path="/go" element={<Go />} />
            </Routes>
          </main>
        )}
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
